import Responsive from "react-responsive"

const MOBILE_BREAKPOINT = 730
export const Desktop = (props) => <Responsive {...props} minWidth={MOBILE_BREAKPOINT + 1} />
export const Mobile = (props) => <Responsive {...props} maxWidth={MOBILE_BREAKPOINT} />
